/**
 * bc-quick-specs — variant-reactive refresh for the quick-specs block.
 *
 * The block lives in the product-information section, but Horizon's
 * variant-picker morphs ONLY itself on a regular PDP (see the bc-mod in
 * assets/variant-picker.js), so the block's server-rendered values go stale
 * when the selected variant changes. The VariantUpdateEvent carries the full
 * re-rendered section document (event.detail.data.html) — rendered with the
 * NEW variant selected — so this module lifts the freshly rendered block out
 * of that fragment and swaps its content into the live DOM.
 *
 * Loaded only by blocks/bc-quick-specs.liquid when the block is in
 * variant-linked mode (the variant carries custom.linked_webbing); static
 * quick specs never change per variant and skip this file entirely.
 */
(() => {
  if (window.__bcQuickSpecsWired) return;
  window.__bcQuickSpecsWired = true;

  const esc = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&'));

  document.addEventListener('variant:update', (event) => {
    const doc = event.detail?.data?.html;
    if (!doc || typeof doc.querySelector !== 'function') return;

    document.querySelectorAll('[data-bc-quick-specs]').forEach((el) => {
      // Combined-listing / multi-form safety: only react to this block's product.
      const pid = el.getAttribute('data-bc-quick-specs') || '';
      const eventPid = event.detail?.data?.productId;
      if (pid && eventPid && String(eventPid) !== pid) return;

      const fresh = doc.querySelector(`[data-bc-quick-specs="${esc(pid)}"]`);
      if (!fresh || fresh === el) return;
      el.hidden = fresh.hidden;
      el.innerHTML = fresh.innerHTML;
    });
  });
})();
